// extracted by mini-css-extract-plugin
module.exports = {"primary":"pill-icon_primary__17TJQ","label":"pill-icon_label__wWJ2d","secondary":"pill-icon_secondary__N_WJp","dark":"pill-icon_dark___tEsI"};